import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

export default {
    controller: new ScrollMagic.Controller(),
    init() {
        if ($('body').hasClass('home')) {
            this.loadFocusThemes();
            this.loadMountains();
            this.loadMagazineHome();
        }
    },
    loadFocusThemes() {

        new ScrollMagic.Scene({
            triggerElement: '.focus-themes',
            triggerHook: 1,
            duration: 0,    // the scene should last for a scroll distance of
            offset: -80,        // start this scene after scrolling for 50px
        })
            // .addIndicators()
            .addTo(this.controller)
            .on("enter", (e) => {
                $('.focus-themes.lazy-img, .focus-themes .lazy-img').each(function () {
                    let url = $(this).data('background');
                    $(this).css('background-image', "url(" + url + ")");

                });
            });


    },
    loadMountains() {

        new ScrollMagic.Scene({
            triggerElement: '.travelogue-in-progress',
            triggerHook: 1,
            duration: 0,    // the scene should last for a scroll distance of
            offset: -100,        // start this scene after scrolling for 50px
        })
            // .addIndicators()
            .addTo(this.controller)
            .on("enter", (e) => {
                $('.home-mountains .lazy-img').each(function () {
                    let url = $(this).data('background');
                    $(this).css('background-image', "url(" + url + ")");

                });
            });


    },
    loadMagazineHome() {

        new ScrollMagic.Scene({
            triggerElement: '.magazine-home',
            triggerHook: 1,
            duration: 0,    // the scene should last for a scroll distance of
            offset: -100,        // start this scene after scrolling for 50px
        })
            // .addIndicators()
            .addTo(this.controller)
            .on("enter", (e) => {
                $('.magazine-home .lazy-img').each(function () {
                    let url = $(this).data('background');
                    $(this).css('background-image', "url(" + url + ")");

                });
            });


    }


};


// WEBPACK FOOTER //
// ./assets/js/libs/HomeLazyLoad.js